import { jsx as o, jsxs as n, Fragment as D } from "react/jsx-runtime";
import f from "./ODSCollapseDown.a8_lm2jI.js";
import { O as b } from "./ODSLogo.dM3TU2ay.js";
import { S as I } from "./index.J3BKoY__.js";
import { c as S } from "./index.CWkFp9WS.js";
import m from "react";
import { u as E } from "./viewport-size.DKLty78u.js";
import '../assets/ODSFooter.css';const M = (e) => {
  const {
    className: t,
    children: a,
    variant: r = "standard",
    extendedNavItems: l = [],
    logoProps: s,
    socialLabel: i,
    socialIcons: c,
    slotElement: d,
    contentSlot: u,
    copyrightText: C,
    ...v
  } = e, L = E(), x = m.Children.toArray(a).some(
    (h) => !m.isValidElement(h) || h.type !== y
  );
  return /* @__PURE__ */ o(
    "footer",
    {
      role: "contentinfo",
      className: S("ODSFooter", `ODSFooter--variant-${r}`, t),
      ...v,
      "data-scheme": "black",
      children: x ? a : /* @__PURE__ */ n(D, { children: [
        r === "extended" ? /* @__PURE__ */ o(O, { items: l, viewport: L }) : null,
        r === "minimal" ? null : /* @__PURE__ */ o(
          F,
          {
            logoProps: s,
            socialLabel: i,
            socialIcons: c,
            slotElement: d,
            contentSlot: u
          }
        ),
        /* @__PURE__ */ o(p, { copyrightText: C, children: a })
      ] })
    }
  );
};
M.displayName = "ODSFooter";
const O = ({
  items: e,
  viewport: t = "large",
  ...a
}) => {
  const r = (l, s) => /* @__PURE__ */ o(
    g,
    {
      text: l.text ?? l.label,
      viewport: t,
      children: l.content
    },
    l.id ?? s
  );
  return /* @__PURE__ */ o("nav", { className: "ODSExtendedNav-Wrapper", "data-scheme": "white", ...a, children: /* @__PURE__ */ o("div", { className: S("ODSExtendedNav", "ODSFooter-Container"), children: t === "medium" ? /* @__PURE__ */ n(D, { children: [
    /* @__PURE__ */ o("div", { "data-column": "1", children: e.slice(0, e.length / 2).map(r) }),
    /* @__PURE__ */ o("div", { "data-column": "2", children: e.slice(e.length / 2, e.length).map(r) })
  ] }) : e.map(r) }) });
};
O.displayName = "ODSExtendedNav";
const F = (e) => {
  const { socialLabel: t, socialIcons: a, slotElement: r, contentSlot: l, logoProps: s } = e, i = l ?? r, c = a != null, d = i != null && !c;
  return /* @__PURE__ */ n(
    "div",
    {
      className: S("ODSFooterLogo", "ODSFooter-Container", {
        "ODSFooterLogo--has-content": c || d,
        "ODSFooterLogo--has-social": c,
        "ODSFooterLogo--has-slot": d
      }),
      children: [
        /* @__PURE__ */ o("div", { className: "ODSFooterLogo-LogoContainer", children: /* @__PURE__ */ o(b, { type: "secondary", ...s }) }),
        c && /* @__PURE__ */ n("div", { className: "ODSFooterLogo-Social", children: [
          t && /* @__PURE__ */ o("h2", { className: "ODSFooterLogo-SocialLabel", children: t }),
          /* @__PURE__ */ o("div", { className: "ODSFooterLogo-SocialIcons", children: a })
        ] }),
        d && /* @__PURE__ */ o("div", { className: "ODSFooterLogo-Slot", children: i })
      ]
    }
  );
};
F.displayName = "ODSFooterLogo";
const p = (e) => {
  const { copyrightText: t = "© Deutsche Telekom AG", children: a } = e;
  return /* @__PURE__ */ n("div", { className: S("ODSFooterMinimal", "ODSFooter-Container"), children: [
    t && /* @__PURE__ */ o("span", { className: "ODSFooterMinimal-Copyright", children: t }),
    /* @__PURE__ */ o("div", { className: "ODSFooter-Links", children: a })
  ] });
};
p.displayName = "ODSFooterMinimal";
const g = ({
  text: e,
  viewport: t = "large",
  children: a
}) => t === "small" ? /* @__PURE__ */ o(N, { text: e, viewport: t, children: a }) : /* @__PURE__ */ n("div", { className: "ODSFooterCategory", children: [
  /* @__PURE__ */ o("h2", { className: "ODSFooterCategory-Label", children: e }),
  /* @__PURE__ */ o("div", { className: "ODSFooterCategory-Content", children: a })
] });
g.displayName = "ODSFooterCategory";
const N = (e) => {
  const { text: t, children: a } = e, [r, l] = m.useState(!1);
  return /* @__PURE__ */ n("div", { className: "ODSFooterCategory", children: [
    /* @__PURE__ */ o("h2", { className: "ODSFooterCategory-LabelWrapper", children: /* @__PURE__ */ n(
      "button",
      {
        className: "ODSFooterCategory-Label",
        "aria-expanded": r,
        onClick: () => l(!r),
        children: [
          t,
          /* @__PURE__ */ o(
            f,
            {
              className: "ODSFooterCategory-LabelIcon",
              size: 16,
              decorative: !0
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ o("div", { className: "ODSFooterCategory-Content", hidden: !r, children: a })
  ] });
};
N.displayName = "ODSFooterCategorySmall";
const y = m.forwardRef((e, t) => {
  const { asChild: a, text: r, label: l, children: s, ...i } = e;
  return /* @__PURE__ */ o(a ? I : "a", { ref: t, className: "ODSFooterMenuItem", ...i, children: a ? s : /* @__PURE__ */ o("span", { children: r ?? l }) });
});
y.displayName = "ODSFooterMenuItem";
export {
  M as O,
  y as a,
  O as b
};
//# sourceMappingURL=ODSFooter.t4EhmrYz.js.map
